"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.state = exports.get = void 0;
const lodash_1 = require("lodash");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function get(key) {
    return (s) => {
        if (key) {
            return lodash_1.get(s.config.config, key);
        }
        return s.config.config;
    };
}
exports.get = get;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function state(s) {
    const { errorMessage, isProcessing } = s.config;
    return { errorMessage, isProcessing };
}
exports.state = state;
//# sourceMappingURL=selectors.js.map